export const MESSAGE_TOP_PX = 48; // + 8 fox internal padding = 56px
